// extracted by mini-css-extract-plugin
module.exports = {"termsTitle":"GxA8J1","termsLine":"c4yPLgE","termsSectionTitle":"i7NU3b","termsSectionContent":"BkQuNW","termsSectionList":"Z3vnK3","termsSectionListItem":"l7gWzF","icon":"c5L5_Yv"};